import { enCurrency } from 'enums/enCurrency';

export const isInternationalCurrency = (currency: enCurrency) => currency !== enCurrency.BRL;
